module.exports = __webpack_public_path__ + "media/images/shared/logos/kristianstad-dbed1165f738915e94a703bf85001ff7.jpg";